import type { EditGroupActivity } from './activities-management.model';

export type ActivityDrawerSessionState = {
  visible: boolean;
  skipEnterAnimation: boolean;
  scrollPosition: number;
  draft: EditGroupActivity | null;
  original: EditGroupActivity | null;
  level: string;
  originalLevel: string;
  editingName: boolean;
  editingDescription: boolean;
  editingRouteUrl: boolean;
  editingSport: boolean;
  editingLevel: boolean;
  coverPhotoMenuVisible: boolean;
  coverPhotoFailed: boolean;
  saveSuccessVisible: boolean;
  discardSuccessVisible: boolean;
  participantsExpanded: boolean;
  keepUndoInEditMode: boolean;
};

export const createEmptyActivityDrawerSessionState = (): ActivityDrawerSessionState => ({
  visible: false,
  skipEnterAnimation: false,
  scrollPosition: 0,
  draft: null,
  original: null,
  level: 'all',
  originalLevel: 'all',
  editingName: false,
  editingDescription: false,
  editingRouteUrl: false,
  editingSport: false,
  editingLevel: false,
  coverPhotoMenuVisible: false,
  coverPhotoFailed: false,
  saveSuccessVisible: false,
  discardSuccessVisible: false,
  participantsExpanded: false,
  keepUndoInEditMode: false
});
